import React from "react";
var __jsx = React.createElement;
import { faXmark } from "@fortawesome/pro-regular-svg-icons";
import AwesomeIcon from "../AwesomeIcon";
import { CreateEditPatientReminder } from "../PatientReminder/AddEditPatientReminder";
import { t } from "i18next";
import { trackEvent } from "../../utils/mixpanel";
import { MIXPANEL_EVENTS } from "../../utils/mixpanelEvents";
var CreateEditReminder = function CreateEditReminder(_ref) {
  var patientUid = _ref.patientUid,
    onCloseCreateEditModal = _ref.onCloseCreateEditModal,
    refetchReminders = _ref.refetchReminders,
    selectedReminder = _ref.selectedReminder,
    workspaceId = _ref.workspaceId;
  var isEditMode = !!(selectedReminder !== null && selectedReminder !== void 0 && selectedReminder.id);
  var headerTitleText = isEditMode ? t("label.task", "Task") : t("label.create_task", "Create Task");
  return /*#__PURE__*/React.createElement("div", {
    className: "flex min-h-0 h-full flex-col bg-white text-gray-800 dark:bg-gray-800 dark:text-gray-100"
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex items-center justify-between gap-3 px-5 py-[7px] border-b border-gray-300 dark:border-gray-700",
    style: selectedReminder !== null && selectedReminder !== void 0 && selectedReminder.isAira ? {
      backgroundImage: "linear-gradient(90deg, rgba(255, 120, 105, 0.25) 0%, rgba(232, 132, 130, 0.25) 30.77%, rgba(201, 149, 164, 0.25) 65.38%, rgba(152, 174, 217, 0.25) 100%)"
    } : {}
  }, /*#__PURE__*/React.createElement("span", {
    className: "min-w-0 flex-1 truncate text-left font-medium text-base text-gray-800 dark:text-gray-100"
  }, (selectedReminder === null || selectedReminder === void 0 ? void 0 : selectedReminder.isAira) && /*#__PURE__*/React.createElement("img", {
    src: "/assets/icons/aira-logo.svg",
    alt: "AIRA",
    className: "w-[15px] h-[15px] inline mr-3"
  }), headerTitleText), /*#__PURE__*/React.createElement("button", {
    type: "button",
    onClick: function onClick() {
      trackEvent(MIXPANEL_EVENTS.REMINDER_FORM_DISMISSED);
      onCloseCreateEditModal();
    },
    className: "shrink-0 rounded p-1.5 text-gray-600 transition-colors hover:bg-gray-100 hover:text-gray-900 dark:text-gray-200 dark:hover:bg-gray-700 dark:hover:text-white",
    "aria-label": t("button.close") || "Close"
  }, /*#__PURE__*/React.createElement(AwesomeIcon, {
    name: faXmark,
    className: "h-5 w-5"
  }))), /*#__PURE__*/React.createElement("div", {
    className: "flex min-h-0 min-w-0 flex-1 flex-col relative"
  }, /*#__PURE__*/React.createElement(CreateEditPatientReminder, {
    patient_uid: patientUid,
    onCloseModal: onCloseCreateEditModal,
    selectedReminder: selectedReminder,
    refetchReminders: refetchReminders,
    workspaceId: workspaceId
  })));
};
export default CreateEditReminder;